import { X } from "lucide-react";
import styles from "./HelpDialog.module.css";

export interface HelpDialogProps {
  onClose: () => void;
}

export function HelpDialog({ onClose }: HelpDialogProps) {
  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.dialog} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h3>Hilfe</h3>
          <button className={styles.closeBtn} onClick={onClose} aria-label="Schließen">
            <X size={18} />
          </button>
        </div>

        <div className={styles.content}>
          {/* Bildschirm dreht sich */}
          <section className={styles.section}>
            <h4>📱 Bildschirm dreht sich automatisch</h4>
            <p className={styles.desc}>
              KollegePlus ist für das Hochformat optimiert. Damit sich der Bildschirm nicht dreht, kannst du die App installieren oder die Drehung auf deinem Gerät sperren.
            </p>

            <div className={styles.platform}>
              <h5>✅ Beste Lösung: Als App installieren</h5>
              <p style={{ margin: "0 0 0.5rem 0", fontSize: "0.85rem", opacity: 0.8 }}>
                Als installierte App bleibt KollegePlus automatisch im Hochformat.
              </p>

              <strong style={{ fontSize: "0.85rem" }}>🤖 Android (Chrome):</strong>
              <ol>
                <li>Öffne KollegePlus im Chrome-Browser</li>
                <li>Tippe auf das <strong>Drei-Punkte-Menü</strong> (⋮) oben rechts</li>
                <li>Wähle <strong>„Zum Startbildschirm hinzufügen"</strong> oder <strong>„App installieren"</strong></li>
                <li>Bestätige mit <strong>„Installieren"</strong></li>
              </ol>

              <strong style={{ fontSize: "0.85rem" }}>🍎 iPhone / iPad (Safari):</strong>
              <ol>
                <li>Öffne KollegePlus in <strong>Safari</strong> (nicht Chrome!)</li>
                <li>Tippe auf das <strong>Teilen-Symbol</strong> (□↑) unten in der Mitte</li>
                <li>Scrolle nach unten und wähle <strong>„Zum Home-Bildschirm"</strong></li>
                <li>Tippe auf <strong>„Hinzufügen"</strong></li>
              </ol>
            </div>

            <div className={styles.platform}>
              <h5>🔒 Alternative: Drehung am Gerät sperren</h5>

              <strong style={{ fontSize: "0.85rem" }}>🤖 Android:</strong>
              <ol>
                <li>Wische vom oberen Bildschirmrand nach unten</li>
                <li>Tippe auf <strong>„Automatisch drehen"</strong> — Symbol wird grau</li>
              </ol>

              <strong style={{ fontSize: "0.85rem" }}>🍎 iPhone:</strong>
              <ol>
                <li>Öffne das <strong>Kontrollzentrum</strong> (von oben rechts nach unten wischen)</li>
                <li>Tippe auf das <strong>Schloss mit Pfeil</strong> 🔒 — es leuchtet rot</li>
              </ol>
            </div>

            <p className={styles.hint}>
              💡 <strong>Tipp:</strong> Die installierte App funktioniert wie eine normale App — mit eigenem Icon auf dem Startbildschirm und ohne Browser-Adressleiste.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
